module.exports = __webpack_public_path__ + "static/media/hand-peace.ae36b51c.svg";